/**
 * Client-side mirror of the backend rules in `packages/backend/src/constants/tax.ts`.
 *
 * Duplicated rather than shared through `@diagon-alley/common` because that package
 * is a build dependency of the frontend and these are two constants and two regexes —
 * but they must stay in step: the backend DTO and a DB CHECK both enforce the same
 * shape, so a looser rule here only buys the user a round trip to a 400.
 */

export const HSN_CODE_PATTERN = /^\d{2,8}$/;

export const HSN_CODE_MESSAGE = 'Must be 2 to 8 digits (e.g. 6109, 61091000)';

export const GST_RATE_MIN = 0;
export const GST_RATE_MAX = 100;

/** The Indian GST slabs, offered as picker suggestions — any rate is still accepted. */
export const COMMON_GST_RATES = ['0', '0.25', '3', '5', '12', '18', '28'];

/** Returns an error message for a filled-in HSN field, or null when it is fine. */
export const validateHsnCode = (raw: string): string | null => {
    const trimmed = raw.trim();
    if (!trimmed) return null;

    return HSN_CODE_PATTERN.test(trimmed) ? null : HSN_CODE_MESSAGE;
};

/** Returns an error message for a filled-in GST field, or null when it is fine. */
export const validateGstRate = (raw: string | number): string | null => {
    if (raw === '' || raw === null || raw === undefined) return null;

    const value = Number(raw);
    if (!Number.isFinite(value)) return 'Must be a number';

    return value < GST_RATE_MIN || value > GST_RATE_MAX
        ? `Must be between ${GST_RATE_MIN} and ${GST_RATE_MAX}`
        : null;
};
